import React, { useState,useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Helmet } from "react-helmet";
import GenerateToken from "../components/GenerateToken";
import SocialCircle from "../components/SocialCircle";
import axios from "axios";

const FAQSection = () => {
  useEffect(() => {
        const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
        axios.post(`${backendUrl}/api/analytics/visit`, { page: "Contact Page" })
          .then(res => console.log("CContact Page visit recorded:", res.data))
          .catch(err => console.error("Analytics error:", err));
      }, []);
  const [selectedMain, setSelectedMain] = useState(0);
  const [openQuestions, setOpenQuestions] = useState([]);
  //  const [keywords, setKeywords] = useState('');


  const faqs = [
    {
      "main": "ORDERS & PAYMENT",
      "sub": [
        {
          "question": "What should I do if my payment fails?",
          "description": "If your payment fails, first ensure that your card details, UPI ID, or net banking credentials are correct. Check if your bank has blocked the transaction or if your internet connection is stable. If the issue persists, try another payment method or contact our customer support team. We're here to help resolve payment issues quickly so you can complete your purchase without hassle."
        },
        {
          "question": "How do I cancel the order I have placed?",
          "description": "To cancel an order, go to the 'My Orders' section of your account, find the order you wish to cancel, and click on the 'Cancel Order' option. Please note that cancellations are only possible before the order is shipped. Once shipped, you can initiate a return or exchange process after receiving the product."
        },
        {
          "question": "I want to place an order but I don’t want any price tag or invoice attached as it is a gift for someone. Is it possible?",
          "description": "Yes! When placing your order, select the 'Gift Option' at checkout. This ensures that the price tags and invoices are not included in the package. You can even include a personalized message to make your gift extra special."
        },
        {
          "question": "Can I use UPI ID for payment?",
          "description": "Absolutely! We accept UPI payments for a seamless checkout experience. Enter your UPI ID during the payment process, approve the request on your UPI app, and your order will be confirmed in no time."
        },
        {
          "question": "How can I get my order delivered faster?",
          "description": "If you need your t-shirts delivered quickly, opt for our expedited shipping option at checkout. Depending on your location, this may significantly reduce delivery times. Additional charges may apply for faster delivery services."
        },
        {
          "question": "I wish to add a few more products in my order. Will it be possible?",
          "description": "Currently, we are unable to modify an existing order once it has been placed. However, you can place a new order for the additional t-shirts or products you'd like. We'll ensure both orders are delivered as efficiently as possible."
        },
        {
          "question": "Why can’t I see the Cash On Delivery (COD) option?",
          "description": "The Cash On Delivery (COD) option may not be available for certain pin codes or high-value orders. If COD is unavailable, consider using one of our other secure payment methods like UPI, credit/debit cards, or net banking."
        },
        {
          "question": "Is there any additional charge for Cash On Delivery (COD) orders?",
          "description": "Yes, a nominal convenience fee may apply to COD orders. The exact charge will be displayed on the checkout page before you place your order. This helps us manage COD processing costs efficiently."
        },
        {
          "question": "How to place an order?",
          "description": "Placing an order is simple! Browse through our collection of trendy t-shirts, select your preferred size and color, and add the items to your cart. Once you're ready, proceed to checkout, provide your shipping details, and complete the payment process. A confirmation email will be sent to you shortly."
        },
        {
          "question": "How do I know if my order was placed successfully?",
          "description": "Once your order is successfully placed, you'll receive an email confirmation with all the details, including the order number and estimated delivery date. You can also check the 'My Orders' section in your account for updates."
        },
        {
          "question": "How do I check the status of my order?",
          "description": "To track your order, log in to your account and navigate to the 'Track Order' section. Here, you’ll find real-time updates on your order’s progress, from processing to shipment and delivery."
        }
      ]
    }
    ,
    {
      "main": "SHIPPING & TRACKING",
      "sub": [
        {
          "question": "How do I track my address?",
          "description": "You can easily manage and track your saved addresses by visiting the 'My Address' section in your profile. This section allows you to add, edit, or delete addresses to ensure accurate delivery. For any address-related issues, our support team is available to assist you."
        },
        {
          "question": "Can I change my address when the order is placed?",
          "description": "Address changes are allowed within 2 hours of placing the order. Simply contact our support team with your order ID, and they will assist you in updating the delivery address. Note that address changes may not be possible once the order is shipped."
        },
        {
          "question": "What if my order is undelivered?",
          "description": "If your order cannot be delivered due to an incorrect address, unavailability, or other reasons, it will be returned to us. Once the package is received back at our facility, a refund will be initiated to your original payment method. Please ensure your address and contact details are accurate to avoid delivery issues."
        },
        {
          "question": "How long does it take to deliver my order?",
          "description": "Delivery typically takes 3-7 business days, depending on your location. For metro cities, orders may arrive sooner, while remote areas may take slightly longer. You will receive regular updates about your order status and expected delivery date via email or SMS."
        },
        {
          "question": "Are there any additional shipping charges?",
          "description": "Shipping charges vary based on your location, order value, and delivery speed selected. Standard shipping is often free for qualifying orders, while express delivery options may incur additional costs. The exact charges will be displayed at the checkout page before you complete your purchase."
        },
        {
          "question": "How can I track my return status?",
          "description": "To track your return status, log in to your account and navigate to the 'Returns' section in your dashboard. Here, you’ll find real-time updates about your return request, including pickup status, refund processing, and resolution timelines."
        },
        {
          "question": "Can I get my orders on weekends?",
          "description": "Yes, we offer weekend deliveries in select regions to ensure you receive your orders conveniently. Weekend delivery availability depends on the courier partner servicing your area. You will be informed about delivery options at checkout."
        },
        {
          "question": "Are there any cancellation charges?",
          "description": "No charges apply if the cancellation is done before the order is shipped. However, once the order is dispatched, cancellation might not be possible, and you may need to initiate a return after delivery. For timely assistance, contact our support team as soon as possible."
        },
        {
          "question": "Can I get my orders on weekdays?",
          "description": "Yes, all orders are eligible for weekday deliveries. Our courier partners work diligently to deliver your package Monday through Friday. You’ll receive a notification when your order is out for delivery."
        },
        {
          "question": "How can I skip my shipping charges?",
          "description": "You can skip shipping charges by placing an order above the minimum order value threshold. For example, orders above INR 999 qualify for free delivery. Take advantage of this offer to save on shipping costs while shopping for your favorite products."
        },
        {
          "question": "What should be my minimum amount of order to get free delivery?",
          "description": "To enjoy free delivery, ensure your total order value exceeds INR 999. This offer is applicable on all products, making it easy for you to save on shipping charges while shopping for premium quality t-shirts and accessories."
        }
      ]
    }
    ,
    {
      "main": "EXCLUSIVE MEMBERSHIP",
      "sub": [
        {
          "question": "What are the benefits of membership?",
          "description": "As a member, you gain access to numerous exclusive benefits, including free shipping on all orders, special discounts that are not available to non-members, and early access to upcoming sales and new arrivals. Membership ensures a premium shopping experience tailored just for you."
        },
        {
          "question": "Do shipping charges apply when I have a membership?",
          "description": "No, as a valued member, you will enjoy free shipping on all your orders, regardless of the order value. This benefit allows you to shop more freely without worrying about additional shipping costs."
        },
        {
          "question": "What are the membership charges?",
          "description": "The membership charges depend on the plan you choose. We offer flexible plans, including monthly, quarterly, and yearly memberships. Visit the 'Membership' page for a detailed breakdown of fees and benefits included in each plan."
        },
        {
          "question": "Can I cancel my membership midway?",
          "description": "Yes, you can cancel your membership at any time. However, please note that membership fees are non-refundable, and you will continue to enjoy the benefits until the end of your current billing cycle."
        },
        {
          "question": "Can I use wallet money for payment?",
          "description": "Absolutely! Wallet money can be utilized for transactions, including membership purchases, provided it meets the eligibility criteria. This makes your shopping experience even more convenient and rewarding."
        },
        {
          "question": "Can I buy yearly membership?",
          "description": "Yes, we offer yearly membership plans that provide the most value for frequent shoppers. By opting for a yearly membership, you can enjoy uninterrupted benefits for a full year at a discounted rate compared to shorter-term plans."
        },
        {
          "question": "How to buy membership?",
          "description": "Purchasing a membership is simple. Log in to your account, navigate to the 'Membership' section, select your preferred plan, and complete the payment process. Once the payment is confirmed, your membership will be activated immediately."
        },
        {
          "question": "Can I apply auto-renewal on my membership?",
          "description": "Yes, auto-renewal is available to ensure you never miss out on your membership benefits. Enable this feature in your membership settings, and your subscription will automatically renew at the end of each billing cycle."
        },
        {
          "question": "How to cancel auto-renewal on membership?",
          "description": "You can cancel auto-renewal anytime by visiting your membership settings. Simply toggle off the auto-renewal option, and your membership will not renew at the end of your current billing period."
        },
        {
          "question": "Is the fee all-inclusive?",
          "description": "Yes, the membership fee is all-inclusive and covers all the benefits provided under your chosen plan. There are no hidden charges, ensuring transparency and a hassle-free experience for our members."
        },
        {
          "question": "Can I use promo codes with membership?",
          "description": "Yes, as a member, you are eligible to use promo codes on your orders. Combine your membership discounts with promo codes for additional savings on your favorite products."
        }
      ]
    }
    ,
    {
      "main": "RETURNS, EXCHANGE & REFUND",
      "sub": [
        {
          "question": "Can I cancel my order when it is shipped?",
          "description": "Unfortunately, orders that have already been shipped cannot be canceled. However, once you receive the item, you can initiate a return request to process a refund or exchange, depending on the product's eligibility."
        },
        {
          "question": "Can I cancel my cancellation request?",
          "description": "Yes, you have the option to cancel your cancellation request before the order is processed or dispatched. Simply visit your order history and update your request to proceed."
        },
        {
          "question": "When can I get an exchange product delivered?",
          "description": "Exchange products are typically delivered within 7 business days from the date the returned item is successfully picked up and quality-checked."
        },
        {
          "question": "When will my refund get initiated?",
          "description": "Refunds are initiated within 3-5 business days after your return has been processed and passed our quality check. The exact time may vary based on your payment method."
        },
        {
          "question": "Where will my refund money go: wallet or bank account?",
          "description": "Refunds are credited back to your original payment method, such as a bank account, credit card, or wallet. You can also choose to receive the refund in your wallet for quicker access and future purchases."
        },
        {
          "question": "How many times can I exchange my order?",
          "description": "Each order can be exchanged once for the same product in a different size or variant. Multiple exchanges for the same item are not supported."
        },
        {
          "question": "I created an exchange request. When will it get picked?",
          "description": "Exchange pickups are usually scheduled within 48 hours of placing your request. You will be notified about the exact pickup time via email or SMS."
        },
        {
          "question": "Can I return my customized T-shirt or other items?",
          "description": "Customized products, including T-shirts with personalized prints or other bespoke items, are not eligible for return or exchange due to their unique nature."
        },
        {
          "question": "Do any charges apply when I cancel or exchange orders?",
          "description": "No, we do not charge any additional fees for order cancellations or exchanges. These services are free to ensure your shopping experience remains hassle-free."
        },
        {
          "question": "I created a cancel request. When will it get picked?",
          "description": "Cancel requests do not require a product pickup. Once your cancellation is approved, your refund will be processed promptly as per your payment method."
        },
        {
          "question": "Can I transfer wallet money to my bank account?",
          "description": "Wallet money cannot be transferred to your bank account. However, it can be used for future purchases on our platform, making your next shopping experience even more convenient."
        }
      ]
    }
    ,
    {
      "main": "OFFERS & COMBOS",
      "sub": [
        {
          "question": "What are combo orders?",
          "description": "Combo orders consist of specially curated bundles of products offered at a discounted price. These combos allow you to purchase multiple items together while saving more compared to buying them individually."
        },
        {
          "question": "Do offers get applied to all the products?",
          "description": "Offers are applicable only to eligible products as specified in the promotion. Please check the product page or the terms of the offer for detailed eligibility criteria before placing your order."
        },
        {
          "question": "Can I buy other products with a combo offer?",
          "description": "Yes, you can add additional products to your cart along with combo offers. However, discounts or offers on combo products do not apply to other items unless stated otherwise."
        },
        {
          "question": "Can I avail multiple combo orders together?",
          "description": "Absolutely! You can purchase multiple combo offers in a single transaction, enjoying the benefits of each combo. Make sure to check the terms and conditions for any restrictions."
        },
        {
          "question": "Does canceling one product from my combo offers affect my order?",
          "description": "If you cancel an item that is part of a combo offer, it may void the discount for the remaining products in the combo. In such cases, the individual prices of the other items will apply."
        },
        {
          "question": "How can I get coupon codes?",
          "description": "You can receive coupon codes by signing up for our newsletter, following us on social media, or visiting our dedicated offers page. Stay updated to grab the latest deals and discounts."
        },
        {
          "question": "How many months are coupon codes valid?",
          "description": "The validity period of coupon codes varies depending on the specific promotion. Always check the terms and conditions associated with each coupon for details about its expiration date."
        },
        {
          "question": "Can I share coupon codes?",
          "description": "Yes, most coupon codes can be shared with friends or family unless explicitly mentioned in the terms and conditions. Shared codes can help others save while shopping with us."
        },
        {
          "question": "Can I use a single coupon code twice on different orders?",
          "description": "In general, coupon codes are valid for single-use only. However, certain promotions may allow multiple uses. Refer to the specific coupon terms for clarity."
        },
        {
          "question": "Can I add money to the wallet?",
          "description": "Yes, you can add money to your wallet through the wallet top-up feature available in your account settings. Wallet money offers a convenient way to make quick payments for your orders."
        },
        {
          "question": "How can wallet money be used with combo orders?",
          "description": "Wallet money can be utilized during checkout to pay for eligible combo orders. Simply select your wallet as the payment method to seamlessly apply the available balance."
        }
      ]
    }
    ,
    {
      "main": "SALE TERMS AND CONDITIONS",
      "sub": [
        {
          "question": "When does the sale start?",
          "description": "The start and end dates of our sales are typically announced on our website's homepage and shared with our subscribers via email notifications. Make sure to sign up for updates so you don’t miss out on any exciting offers."
        },
        {
          "question": "Why is delivery not available at my pin code?",
          "description": "Delivery availability is determined by the courier services operating in your area. Some remote or restricted areas may not be covered by our delivery partners. Please check with our customer support team for more information on delivery options to your pin code."
        },
        {
          "question": "Can I get gift wrapping?",
          "description": "Yes, we offer gift wrapping for select products. You can choose the gift wrapping option during checkout, and we'll take care of the rest. This service is available for both regular and sale items, though some exclusions may apply."
        },
        {
          "question": "What are the return and refund policies?",
          "description": "Our return and refund policies are designed to make your shopping experience hassle-free. Please visit our dedicated return and refund policy page for detailed instructions on how to return products, eligibility criteria, and the time frame for processing refunds."
        },
        {
          "question": "What is the self-ship policy?",
          "description": "If our courier services are unavailable in your area, we allow customers to self-ship returns. In such cases, please contact our customer support for guidance on the process and to ensure your return is accepted. Please note that customers are responsible for return shipping costs under this policy."
        }
      ]
    }
    ,
  ];
  

  const toggleQuestion = (question) => {
    setOpenQuestions((prev) =>
      prev.includes(question)
        ? prev.filter((q) => q !== question)
        : [...prev, question]
    );
  };

  // const keywordsArray = [
  //   ...new Set(
      
  //         faqs.flatMap((faq) =>
  //           faq.sub.flatMap((item) =>
  //             [item.question, item.description].join(' ').split(/\s+/).map((word) => word.toLowerCase())
  //           )
  //         )
  //       )
   
  // ];
  
  // // Adding streetwear-related keywords
  const streetwearKeywords = ["streetwear", "hoodies", "graphic tees", "sneakers", "fashion", "urban", "stylish", "casual wear"];
  // const finalKeywordsArray = [...keywordsArray, ...streetwearKeywords];

  // setKeywords(finalKeywordsArray.join(', '));

  return (
       
   
     <>
        {/* Helmet for SEO */}
        <Helmet>
         <title>Contact Page</title>
         <meta name="description" content="Explore our exclusive collection of sweatshirts. Available in various styles, sizes, and designs." />
         <meta name="keywords" content={streetwearKeywords} />
       </Helmet>
    
    <div className="flex flex-col md:flex-row gap-5 my-8 px-6 sm:px-8 lg:px-20 max-w-7xl mx-auto text-sm mt-20">
      
  
      
      {/* Left Sidebar */}
      <div className="w-full md:w-1/4 border-r pr-4 md:pr-8">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`cursor-pointer py-2 ${
              selectedMain === index ? "font-bold border-l-4 pl-2 border-[#FF4902]" : ""
            }`}
            onClick={() => setSelectedMain(index)}
          >
            {faq.main}
          </div>
        ))}
      </div>

      {/* Right Content */}
      <div className="w-full md:w-3/4">
        {faqs[selectedMain]?.sub.map((item, index) => (
          <div key={index} className="border-b pb-3 mb-3">
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => toggleQuestion(item.question)}
            >
              <p>{item.question}</p>
              <span className="ml-2">
                {openQuestions.includes(item.question) ? (
                  <FaChevronUp size={16} className="text-gray-500" />
                ) : (
                  <FaChevronDown size={16} className="text-gray-500" />
                )}
              </span>
            </div>
            {openQuestions.includes(item.question) && (
              <p className="mt-2 text-gray-600">{item.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

const Contact = () => {
  return (
    <>
    <div>
      <div>
        {/* Black Row Section */}
<div className="w-full bg-black text-white py-8 px-6 text-center">
  <h2 className="text-2xl sm:text-3xl font-bold mb-4">How Can I Help You?</h2>
  <div className="inline-block relative w-96"> {/* Increased width to 64 */}
    <select
      className="appearance-none bg-transparent border border-white text-white px-4 py-2 rounded-md text-sm focus:outline-none w-full"
    >
      <option value="" disabled selected>
        Please select your query
      </option>
      <option value="general" className="bg-black text-white hover:font-bold">
      Order is not Delivered ?
      </option>
      <option value="support" className="bg-black text-white hover:font-bold">
      Order is delivered at different address ?
      </option>
      <option value="orders" className="bg-black text-white hover:font-bold">
      Can I please change my address ?
      </option>
      <option value="feedback" className="bg-black text-white hover:font-bold">
      Cancel Order ?
      </option>
      <option value="myorder" className="bg-black text-white hover:font-bold">
      Exchange my order ?
      </option>
      <option value="product?" className="bg-black text-white hover:font-bold">
      Received damage product?
      </option>
      <option value="oChangeSize" className="bg-black text-white hover:font-bold">
      Can I Change Size of my product ?
      </option>
      <option value="couponcode" className="bg-black text-white hover:font-bold">
      My coupon code didn’t worked ?
      </option>
      <option value="wrongsize" className="bg-black text-white hover:font-bold">
      Received wrong size product ?
      </option>
      
    </select>
    <svg
      className="absolute right-3 top-3 pointer-events-none text-white"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M5.25 7.75L10 12.25L14.75 7.75L15.5 8.5L10 14L4.5 8.5L5.25 7.75Z" />
    </svg>
  </div>
</div>
        <h2 className="text-center text-3xl font-bold mb-5 mt-7">FAQs</h2>
        <FAQSection />
        <GenerateToken/>
        <SocialCircle/>
      </div>
    </div>

</>
  );
};

export default Contact;
